export const ownerscabinImageOptions = {
  legacy: true,
  prefix: 'X4_9_Interior',
  angle: 'ownerscabin',
  staticOptions: {
    Worktop: 1,
    Fabric: 1,
    Pouffes: 1,
    CupboardsSaloon: 1,
    SplitBerth: 1,
    Backrest: 1,
    TableBox: 1,
    CupboardsAftCabin: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/ownerscabin.js